<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    @change="setAgentId"
    prepend-icon="mdi-account blue--text"
    :label="componentName"
    item-text="name"
    item-value="id"
    dense
    filled
    hide-details
    solo-inverted
    clearable
    :no-data-text="$t('autoCompleteNoData')"
    @click:clear="clearable()"
  ></v-autocomplete>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-agents",
  data: () => ({
    select: null,
    isLoading: false,
    items: [],
    search: null,
    endpoint: "",
    level: "",
  }),
  async created() {
    // ====================================================
    // 1. Setup Endpoint:
    this.level = localStorage.getItem("level");

    this.endpoint = this.level === "collaborator" ?
      `colab/affiliates/listAffiliates` :
        `${this.level}/agents/list`;

    // Set get If localManager
    if (this.level === "localManager") {
      this.getAgentsList();
    }

    // Set agents IF RegionalManager && Rote Balance Agent
    // if (
    //   this.level == "regionalManager" &&
    //   this.$route.name == "RegionalManagerFinancialListBalanceRoute"
    // ) {
    //   this.getAgentsList();
    // }
  },
  computed: {
    componentName() {
      const routeName = this.$route.name;

      switch(routeName) {
        case 'AdministratorAffiliatesCpa':
        case 'CollaboratorAffiliatesCpa':
        case 'AdministratorAffiliatesCampaings':
        case 'CollaboratorAffiliatesCampaings':
          return this.$t('affiliate');
        default:
          return this.$t('agents');
      }
    },
    enableAutocompleteAgents() {
      return this.$store.state.filters.autocompleteAgents.enable;
    },
    // 2. IF - Administrator
    id_regional() {
      if (this.level == "administrator" || this.level == "collaborator") {
        return this.$store.state.filters.autocompleteRegionals.id;
      }
      return "";
    },
    // 2.1 IF - Administrator or Regional Manager
    id_local() {
      if (
        this.level == "administrator" ||
        this.level == "regionalManager" ||
        this.level == "collaborator"
      ) {
        return this.$store.state.filters.autocompleteLocals.id;
      }
      return "";
    },
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;
      // Items have already been requested
      if (this.isLoading) return;
      // Request
      this.getAgentsList();
    },
    // ====================================================
    // 3. IF - Administrator
    id_regional(val) {
      val && this.getAgentsList();
    },
    id_local(val) {
      val && this.enableAutocompleteAgents && this.getAgentsList();
    },

    // Observar a "troca de rota" ou o array de "items",
    // e caso tiver id de agente na url por query ou params,
    // filtrar o item, exibir no select e setAgentId no store:
    items() {
      this.selectAgentByQueryOrParams();
    },
    $route() {
      this.selectAgentByQueryOrParams();
    },
  },
  methods: {
    clearable() {
      this.$store.commit("setAgentId", "");
    },

    setAgentId(agentId) {
      this.$store.commit("setAgentId", agentId ? agentId : "");
    },

    async getAgentsList() {
      this.isLoading = true;
      try {
        const response = await this.$request.post(this.endpoint, {
          status: 1,
          id_regional: this.id_regional || "",
          id_local: this.id_local || "",
        });

        if (response.length == 0) {
          this.items = [];
          return;
        }

        this.items = await response.dados.map((item) => ({
          name: `${item.name_agent} (${item.login_agent} - ${item.id})`,
          id: item.id,
        }));
        this.$store.commit("listUsersAgents", this.items);
      } finally {
        this.isLoading = false;
      }
    },

    selectAgentByQueryOrParams() {
      let select;

      if (this.$route.params.id_agent) {
        select = this.items.filter(
          (item) => item.id == this.$route.params.id_agent
        );
      }

      if (this.$route.query.id_agent) {
        select = this.items.filter(
          (item) => item.id == this.$route.query.id_agent
        );
      }

      if (!this.$route.params.id_agent && !this.$route.query.id_agent) {
        return;
      }

      // o if aqui é necessário para evitar
      // erros de agentes bloqueados ou suspensos;
      if (select[0] == undefined) return;

      this.select = select[0];
      this.setAgentId(this.select.id);
    },
  },
};
</script>
